(function () {
  "use strict";

  // Text tweaks for PluralCart's "Save Cart" modal (markup is injected by the app,
  // so we patch it client-side):
  //   - Success message: "Cart saved to <name>. View them here" (here = saved cart link)
  //   - After a save, "Create new" heading gets " - Add another New Cart"

  var VIEW_CLASS = "cp-saved-cart-view";
  var ADD_CLASS = "cp-saved-cart-add-another";
  var ADD_TEXT = " - Add another New Cart";

  var scheduled = false;

  function isVisible(el) {
    return !!el && el.style.display !== "none" && el.getClientRects().length > 0;
  }

  function patchModal(modal) {
    var success = modal.querySelector(".aasaved-cart-success");
    var text = success && success.querySelector(".aasaved-cart-feedback__text");
    var link = text && text.querySelector(".aasaved-cart__success-link");
    var saved = isVisible(success) && !!link;

    // "View them here" after the cart name link
    if (link) {
      var view = text.querySelector("." + VIEW_CLASS);
      if (!view) {
        view = document.createElement("span");
        view.className = VIEW_CLASS;
        view.appendChild(document.createTextNode(". View them "));
        var a = document.createElement("a");
        a.className = "aasaved-cart__success-link";
        a.target = "_blank";
        a.textContent = "here";
        view.appendChild(a);
      }
      // Keep it directly after the app's link (the app may re-render the name)
      if (link.nextSibling !== view) link.parentNode.insertBefore(view, link.nextSibling);
      var hereLink = view.querySelector("a");
      var href = link.getAttribute("href");
      if (hereLink.getAttribute("href") !== href) hereLink.setAttribute("href", href);
    }

    // "Create new - Add another New Cart" once a save has happened
    var heading = modal.querySelector(".aasaved-cart-component:not(.aasaved-cart-existing) .aasaved-cart-header h3");
    if (heading) {
      var add = heading.querySelector("." + ADD_CLASS);
      if (saved && !add) {
        add = document.createElement("span");
        add.className = ADD_CLASS;
        add.textContent = ADD_TEXT;
        heading.appendChild(add);
      } else if (!saved && add) {
        add.remove();
      }
    }
  }

  function run() {
    scheduled = false;
    document.querySelectorAll(".aasaved-cart-dropdown").forEach(patchModal);
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(run);
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ["class", "style", "href"]
  });

  run();
})();
